import { Platform } from "react-native";

const isDevelopment = process.env.NODE_ENV === "development";

const isSilk =
  /(?:; ([^;)]+) Build\/.*)?\bSilk\/([0-9._-]+)\b(.*\bMobile Safari\b)?/.exec(
    navigator.userAgent,
  ) != null;

const localhost = Platform.OS === "android" ? "10.0.2.2" : "localhost";

export const config = {
  isDevelopment,
  pixelDensity: Platform.OS === "android" || isSilk ? 0.5 : 1,
  apiBaseUrls: [
    { region: "dev", url: `http://${localhost}:9000` },
    { region: "us", url: "https://api.us.displays.tw" },
    { region: "eu", url: "https://api.eu.displays.tw" },
    { region: "ap", url: "https://api.apac.displays.tw" },
  ],
  displayStatus: {
    devBypass: true,
    url: isDevelopment
      ? `http://${localhost}:8787/display_status`
      : "https://api.us.displays.tw/display_status",
  },
  tvHostUrl: isDevelopment ? `http://${localhost}:8081` : `https://displays.tw`,
  cmsBaseUrl: isDevelopment
    ? `http://${localhost}:3000`
    : "https://app.displays.tw",

  playlistPollingRate: 10000,
  configPollingRate: 10000,
  notFoundTimeout: 5000,
  mediaStalledTimeout: 60000, // 1 minute
  weather: {
    changePageRate: 10000,
  },
  strength: {
    // Single-page boards carry no pageDurationSeconds by design (the API
    // rejects one for ≤6 sections), so looped playlists dwell this long.
    defaultPageDuration: 30000,
  },
  setupScreen: {
    pollingRate: 5000,
  },
  textCards: {
    startDelay: 5000,
    endDelay: 5000,
    fps: 10,
  },
  eventsPaginated: {
    // keeping this less than the configPollingRate will help
    // prevent against unneccessary additional API calls
    changePageRate: 9000,
  },
  nutrition: {
    changePageRate: 12000,
  },
  announcementsScroller: {
    barHeight: 60,
    fps: 24,
  },
  errorScreenResetDelay: 10, // seconds
};
